import { motion } from "framer-motion";

export default function VisionSection() {
  return (
    <section
      id="vision"
      data-testid="vision-section"
      className="relative bg-white py-28 md:py-40"
    >
      <div className="max-w-4xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-xs font-semibold tracking-[0.25em] uppercase text-[#0A2540]"
        >
          Our Vision — 07
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.05 }}
          className="font-display font-kr mt-8 text-4xl md:text-6xl lg:text-7xl font-extrabold tracking-tight leading-[1.05]"
        >
          기술은 결국,<br />
          <span className="text-slate-400">사람을 위한 것입니다.</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="font-kr mt-10 md:mt-14 text-base md:text-xl text-slate-600 leading-relaxed max-w-2xl mx-auto"
        >
          우리는 기술과 디자인을 연결하여 고객의 성장을 만드는<br className="hidden md:block" />
          디지털 파트너가 되겠습니다.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scaleX: 0 }}
          whileInView={{ opacity: 1, scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.35 }}
          className="mt-14 mx-auto h-px w-24 bg-[#0A2540] origin-center"
        />
      </div>
    </section>
  );
}
